import { render } from "./PowerCleaner.vue?vue&type=template&id=698b7766"
import script from "./PowerCleaner.vue?vue&type=script&lang=js"
export * from "./PowerCleaner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__